<template>
  <brand-module-detail :is-edit='false'>
  </brand-module-detail>
</template>

<script>
import BrandModuleDetail from '../components/BrandModuleDetail'
export default {
  name: 'CreateBrandModule',
  components: {
    BrandModuleDetail
  }
}
</script>
